(function () {
  'use strict';

  /* ─── DOM ─── */
  const loader    = document.getElementById('lo-intro-loader');
  if (!loader) return;

  const counter   = document.getElementById('lo-counter');
  const tagline   = document.getElementById('lo-tagline');
  const barTrack  = document.getElementById('lo-bar-track');
  const barFill   = document.getElementById('lo-bar-fill');
  const iw1       = document.getElementById('lo-iw1');
  const iw2       = document.getElementById('lo-iw2');
  const iw3       = document.getElementById('lo-iw3');

  if (!counter || !iw1 || !iw2 || !iw3) return;

  /* ─── CONFIG from data attributes ─── */
  const COUNTER_DUR = parseInt(loader.dataset.counterDuration, 10) || 3500;
  const WAVE_DUR    = parseInt(loader.dataset.waveDuration, 10)    || 1200;
  const SESSION_ONCE = loader.dataset.sessionOnce === 'true';

  /* ─── SESSION CHECK ─── */
  if (SESSION_ONCE && sessionStorage.getItem('lo-intro-played')) {
    loader.classList.add('lo-loader--hidden');
    [iw1, iw2, iw3].forEach(function (w) { w.style.display = 'none'; });
    return;
  }

  /* ─── EASING ─── */
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  function easeInOutQuart(t) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow(-2 * t + 2, 4) / 2;
  }

  /* ─── ANIMATION HELPERS ─── */
  function slideY(el, from, to, duration, easing, delay) {
    return new Promise(function (resolve) {
      el.style.transform = 'translateY(' + from + '%)';
      setTimeout(function () {
        var start = performance.now();
        function tick(now) {
          var raw = Math.min((now - start) / duration, 1);
          var e = easing(raw);
          el.style.transform = 'translateY(' + (from + (to - from) * e) + '%)';
          if (raw < 1) {
            requestAnimationFrame(tick);
          } else {
            resolve();
          }
        }
        requestAnimationFrame(tick);
      }, delay || 0);
    });
  }

  function animateCounter(dur, cb) {
    var start = performance.now();
    (function tick(now) {
      var raw = Math.min((now - start) / dur, 1);
      var val = Math.round(easeInOutCubic(raw) * 100);
      counter.innerHTML = val + '<span class="lo-loader__percent">%</span>';
      if (barFill) barFill.style.width = (easeInOutCubic(raw) * 100) + '%';
      if (raw < 1) {
        requestAnimationFrame(tick);
      } else if (cb) {
        cb();
      }
    })(performance.now());
  }

  /* ─── RUN INTRO ─── */
  function runIntro() {
    /* Reset positions (waves hidden via CSS, shown later) */
    [iw1, iw2, iw3].forEach(function (w) {
      w.style.transform = 'translateY(0%)';
    });

    /* Count 0 → 100% */
    animateCounter(COUNTER_DUR, function () {

      /* Fade out counter + tagline + bar */
      counter.classList.add('lo-fade-out');
      if (tagline) tagline.classList.add('lo-fade-out');
      if (barTrack) barTrack.classList.add('lo-fade-out');

      /* Pause, then reveal */
      setTimeout(function () {

        /* Show waves now */
        [iw1, iw2, iw3].forEach(function (w) {
          w.style.display = 'block';
        });

        /* Make loader transparent so site shows through */
        loader.style.background = 'transparent';
        loader.classList.add('lo-loader--done');

        /* Stagger waves sliding DOWN — surface first, deep last */
        slideY(iw3, 0, 140, WAVE_DUR, easeInOutQuart, 0);
        slideY(iw2, 0, 140, WAVE_DUR, easeInOutQuart, Math.round(WAVE_DUR * 0.25));
        slideY(iw1, 0, 140, WAVE_DUR, easeInOutQuart, Math.round(WAVE_DUR * 0.5)).then(function () {
          loader.classList.add('lo-loader--hidden');
          [iw1, iw2, iw3].forEach(function (w) { w.style.display = 'none'; });

          /* Mark as played for session */
          if (SESSION_ONCE) {
            try { sessionStorage.setItem('lo-intro-played', '1'); } catch (e) { /* noop */ }
          }
        });

      }, 700);
    });
  }

  /* ─── INIT ─── */
  runIntro();

})();